<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="row items-center q-pb-none">
      <div>
        <div class="text-bold">{{ CustomerInfo.Cs_Name }}
          <q-badge v-if="CustomerInfo.State_Name!=='' && CustomerInfo.State_Name!=null" align="top"
                   :label="CustomerInfo.State_Name" color="brown-5"/>
          <q-badge v-if="CustomerInfo.City_Name!=='' && CustomerInfo.City_Name!=null" align="top"
                   :label="CustomerInfo.City_Name" color="brown-5" class="q-ml-xs"/>
        </div>
        <div class="row q-ml-xs">
          <q-badge color="deep-orange-14"><i>شناسه(</i><b>{{ CustomerInfo.Cs_Code }}</b><i>)</i>
          </q-badge>
          <q-badge v-if="CustomerInfo.RemCredit > 0" color='red-14' class="q-ml-xs"><i>بدهکاری(</i><b
              dir="ltr">{{ Math.abs(CustomerInfo.RemCredit) | toCurrency }}</b><i>) ریال</i>
          </q-badge>
        </div>
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>
    <q-card-actions align="center">
      <q-btn round flat padding="none" size="lg" color="red" icon="add_circle">
        <q-popup-proxy>
          <CustomerReceivePay :customer-info="CustomerInfo" @added-new="addToList"/>
        </q-popup-proxy>
      </q-btn>
    </q-card-actions>
    <q-card-section>
      <q-list>
        <q-item v-for="(item, index) in items.filter(record=> !record.Cs_PayLink)" :key="index">
          <q-item-section avatar>
            <q-icon color="green" name="attach_money"/>
          </q-item-section>
          <q-item-section>
            <div>
              {{ item.Cs_SendLinkDateTime | toJalaliDateTime }}
              <q-badge align="top" v-if="item.BankTitle" color="brown" text-color="white" :label="item.BankTitle"/>
            </div>
          </q-item-section>
          <q-item-section side>
            <q-chip square color="green" text-color="white" :label="item.Cs_Pay | toLoalString"/>
          </q-item-section>
          <q-item-section side>
            <q-btn flat round color="red-14" icon="delete" @click="deletePayItem(item)"
                   v-if="$store.state.roles.some(v=>['admin','can_delete_customer_pay_item'].includes(v))">
              <q-tooltip>
                حذف
              </q-tooltip>
            </q-btn>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerReceivePay from "@/components/customers/CustomerReceivePay";

export default {
  name: "CustomerReceiveList",
  components: {CustomerReceivePay},
  props: {
    CustomerInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: []
    }
  },
  methods: {
    ...mapActions({
      getList: 'Customers/get_customer_pay',
      deleteItem: 'Customers/deletePayItem'
    }),
    addToList(row) {
      this.items.push(row)
    },
    deletePayItem(item) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'رسید دریافتی طرف معامله حذف گردد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteItem(item.ID).then(() => {
          this.items = this.items.filter(record => record.ID === item.ID)
        })
      })
    }
  },
  created() {
    this.getList(this.CustomerInfo.Cs_ID).then((res) => {
      if (res !== undefined) {
        this.items = res
      }
    })
  }
}
</script>

<style scoped>

</style>